import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/RecruiterProfile.css";

const RecruiterProfile = () => {
  const navigate = useNavigate();
  const [recruiter, setRecruiter] = useState(null);
   
  //before intergration code 

  {/*useEffect(() => {
    const storedRecruiter = localStorage.getItem("recruiterInfo");
    if (storedRecruiter) {
      setRecruiter(JSON.parse(storedRecruiter));
    } else {
      navigate("/recruiter-profile");
    }
  }, [navigate]);*/}

  // After Intergration code 26-11-2025
  useEffect(() => {
  //const token = localStorage.getItem("auth_token");
  const token =
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    localStorage.getItem("recruiter_token") ||
    localStorage.getItem("candidate_token");

  //fetch("http://localhost:8000/api/recruiter/me", {
  fetch("http://144.91.102.67:8002/api/recruiter/me", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      {/*const formattedRecruiter = {
                name: data.full_name,
                email: data.email,
                phone: data.contact_number,
                companyName: data.company_name,
                logo: data.company_logo,
                website: data.website,
                industry: data.industry,
                noOfEmployees: data.num_employees,
                address: data.company_address,
                description: data.description,
              };*/}

        const formattedRecruiter = {
                    name: data.full_name,
                    email: data.email,
                    phone: data.contact_number,
                    companyName: data.company_name,
                    logo: data.logo,
                    website: data.website,
                    industry: data.industry,
                    noOfEmployees: data.noOfEmployees,
                    address: data.address,
                    description: data.description,
                    designation: data.designation,
                  };

      localStorage.setItem("recruiterInfo", JSON.stringify(formattedRecruiter));
      setRecruiter(formattedRecruiter);
    })
    .catch((err) => {
      console.error("Error fetching recruiter:", err);
    });
}, []);


  if (!recruiter) {
    return <p>Loading recruiter details...</p>;
  }

  return (
    <div className="recruiter-profile-container">
      {/* Profile Header */}
      <div className="profile-header">
        {/*<div className="profile-logo">
          {recruiter.logo ? (
            <img src={recruiter.logo} alt="Company Logo" />
          ) : (
            <div className="logo-placeholder">{recruiter.companyName?.[0]}</div>
          )}
        </div>*/}
        {/*added on this code on 26-11-2025*/}
        <div className="profile-logo">
              {recruiter?.logo ? (
                <img src={recruiter.logo} alt="Company Logo" />
              ) : (
                <div className="logo-placeholder">{recruiter.companyName?.[0]}</div>
              )}
            </div>
        <div className="profile-info">
          <h2>{recruiter.name}</h2>
          <p className="designation">{recruiter.designation || "Recruiter"}</p>
          <p className="company-name">{recruiter.companyName}</p>
        </div>
      </div>

      {/* Profile Details */}
      <div className="profile-details-card">
        <h3>👤 Personal Information</h3>
        <div className="details-grid">
          <p><strong>Full Name:</strong> {recruiter.name}</p>
          <p><strong>Email:</strong> {recruiter.email}</p>
          <p><strong>Mobile:</strong> {recruiter.phone}</p>
        </div>
      </div>

      <div className="profile-details-card">
        <h3>🏢 Company Information</h3>
        <div className="details-grid">
          <p><strong>Company:</strong> {recruiter.companyName}</p>
          <p><strong>Website:</strong> 
            {recruiter.website ? (
              <a href={recruiter.website} target="_blank" rel="noreferrer">{recruiter.website}</a>
            ) : (
              "N/A"
            )}
          </p>
          <p><strong>Industry:</strong> {recruiter.industry || "N/A"}</p>
          <p><strong>Employees:</strong> {recruiter.noOfEmployees || "N/A"}</p>
          <p><strong>Address:</strong> {recruiter.address || "N/A"}</p>
        </div>

        {recruiter.description && (
          <div className="description">
            <strong>About Company:</strong>
            <p>{recruiter.description}</p>
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="profile-actions">
        <button
          className="edit-profile-btn"
          onClick={() => navigate("/recruiter-onboarding")}
        >
          ✏️ Edit Profile
        </button>
        <button
          className="explore-plans-btn"
          onClick={() => navigate("/plans")}
        >
          🚀 Explore Plans
        </button>
      </div>
    </div>
  );
};

export default RecruiterProfile;

